export default {
  getPlaceList(state) {
    return state.placeList
  },
  getPlace(state) {
    return state.place
  }
}
